//Library modul
import { Component } from "react";
import { connect } from "react-redux";

import dict from "../../Data/dict.json";
import logo_geojson from "../../Assets/svg/logo_geojson.svg"
import { CircularProgress } from "@mui/material";
class downloadgeojson extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feature_filter: [],
      loading: false
    };
  }

  on_download_json = () => {
    try {
      this.setState({loading: true})
    const { layer_id, geo_layer_list, sorted_by } = this.props.layer;

    let geo_layer = geo_layer_list.find((e) => e.geo_layer._id === layer_id);

    const fields = geo_layer?.geo_layer?.fields
      ? geo_layer?.geo_layer?.fields
      : [];

    let geo_filter = this.state.feature_filter;

    // sorting
    let field, sort;
    if (sorted_by?.length > 0) {
      field = sorted_by?.[0]?.field;
      sort = sorted_by?.[0]?.sort;

      const isFromSmall = sort === "desc" ? false : true;
      const key = field;
      geo_filter = geo_filter.sort((a, b) => {
        if (a?.properties?.[key] < b?.properties?.[key])
          return isFromSmall ? -1 : 1;
        if (a?.properties?.[key] > b?.properties?.[key])
          return isFromSmall ? 1 : -1;
        return 0;
      });
    }

    geo_layer = geo_layer?.geo_layer;
    let geojson = geo_layer?.geojson ? geo_layer.geojson_filtered : {};
    const geoJsonFilter = {
      type: "FeatureCollection",
      features: geo_filter,
    };
    let dataJson =
      geo_filter?.length === 1 || geo_filter?.length >= 1
        ? geoJsonFilter
        : geojson;

    const features = dataJson?.features?.map((item) => {
      let properties = {};

      fields
        .filter((data) => data?.isStyle !== true || data?.isStyle === undefined)
        .forEach((data) => {
          properties[data.name] = item.properties[data.key];
        });

      return {
        type: item.type,
        geometry: item.geometry,
        properties: properties,
      };
    });

    const body = {
      type: "FeatureCollection",
      features: features,
    };

    const geojson_text = JSON.stringify(body);
    const element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(geojson_text)
    );
    const file_name = `${geo_layer.name}.geojson`;
    element.setAttribute("download", file_name);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);  
    } catch (error) {
      
    } finally {
      this.setState({loading: false})
    }
  };

  render() {
    const language = localStorage?.language ? localStorage?.language : "ina";
    const loading = this.state.loading
    return (
      <button
        onClick={() => this.on_download_json()}
        data-mapid="clickDownloadGeoJson"
        title={dict?.["Download GEOJSON"]?.[language]?.toUpperCase()}
        className="button_download_data"
      >
        {loading ? 
          (<CircularProgress size={20} thickness={8} sx={{ color: "black"}} />)
          : 
          (<img src={logo_geojson} width={40} alt="icon download geojson" />)
        }
        <p className="layer_action_label inactive_label">Geojson</p>
      </button>
    );
  }
}

const mapStateToProps = (state) => ({
  map: state.map,
  auth: state.auth,
  layer: state.layer,
});

export default connect(mapStateToProps, {})(downloadgeojson);
